export const SOFTLINE_API_CUSTOMER = '/customer-service/customer-service/customer/{{id}}';
export const SOFTLINE_API_CUSTOMER_NOTES =
  '/customer-service/customer-service/customer/{{id}}/notes';
export const SOFTLINE_API_CUSTOMER_MAIN_CONTACT =
  '/customer-service/customer-service/customer/{{id}}/main-contact';
export const SOFTLINE_API_CUSTOMER_CONTACTS =
  '/customer-service/customer-service/customer/{{id}}/contacts';
export const SOFTLINE_API_CUSTOMER_COLLECTORS =
  '/customer-service/customer-service/customer/{{id}}/collectors';
export const SOFTLINE_API_CUSTOMER_CARDS =
  '/customer-service/customer-service/customer/{{id}}/cards';
export const SOFTLINE_API_CUSTOMER_FUEL_CARDS =
  '/customer-service/customer-service/customer/{{id}}/fuel-card';
export const SOFTLINE_API_CUSTOMER_CONDITIONS_SHEET =
  '/customer-service/customer-service/customer/{{id}}/conditions-sheet';
export const SOFTLINE_API_CUSTOMER_SCAN =
  '/customer-service/customer-service/customer/scan/{{type}}/{{code}}';
export const SOFTLINE_API_CUSTOMER_CREDIT_BALANCE =
  '/customer-service/customer-service/customer/{{id}}/credit-balance';
/** Document-bound credit check — lives on the sales-document-service, but it is
    the customer's credit view whenever a document is loaded. */
export const SOFTLINE_API_DOCUMENT_CREDIT_LIMIT =
  '/sales-document-service/sales-document-service/documents/{{id}}/credit-limit';
/** `POST` a new construction site (Baustelle) below the invoicing customer `{{id}}`. */
export const SOFTLINE_API_CUSTOMER_CONSTRUCTION_SITES =
  '/customer-service/customer-service/customer/{{id}}/construction-sites';
/** `PATCH` an existing construction site — partial update, omitted fields stay. */
export const SOFTLINE_API_CUSTOMER_CONSTRUCTION_SITE =
  '/customer-service/customer-service/customer/{{id}}/construction-sites/{{constructionSiteId}}';
/** Delivery customers of `{{id}}` — the construction sites created above appear here. */
export const SOFTLINE_API_CUSTOMER_DELIVERY_CUSTOMERS =
  '/customer-service/customer-service/customer/{{id}}/delivery-customers';
